import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ErrorStore, SharedAnalysisResults } from '@sleipai/sleip-models';
import * as SharedAnalysisResultsActions from '../actions/shared-analysis-results.actions';

export const sharedAnalysisResultsFeatureKey = 'sharedAnalysisResults';

export interface State extends EntityState<SharedAnalysisResults> {
  loaded: boolean;
  loading: boolean;
  error: ErrorStore | null;
}

export const adapter: EntityAdapter<SharedAnalysisResults> =
  createEntityAdapter<SharedAnalysisResults>();

export const initialState: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  error: null,
});

export const sharedAnalysisResultsReducer = createReducer(
  initialState,

  on(
    SharedAnalysisResultsActions.loadSharedAnalysisResultsByIdAndPublicKey,
    (state) => {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
  ),
  on(
    SharedAnalysisResultsActions.loadSharedAnalysisResultsSuccess,
    (state, { data }) =>
      adapter.upsertOne(data, {
        ...state,
        loaded: true,
        loading: false,
      })
  ),
  on(
    SharedAnalysisResultsActions.loadSharedAnalysisResultsListSuccess,
    (state, { data }) =>
      adapter.upsertMany(data, {
        ...state,
        loaded: true,
        loading: false,
      })
  ),
  on(
    SharedAnalysisResultsActions.loadSharedAnalysisResultsFailure,
    (state, { error }) => {
      return {
        ...state,
        loaded: true,
        loading: false,
        error: {
          message: error['message'],
          status: error['status'],
        },
      };
    }
  )
);

export const {
  selectIds: selectSharedAnalysisResultsIdsAdapter,
  selectEntities: selectSharedAnalysisResultsEntitiesAdapter,
  selectAll: selectAllSharedAnalysisResultsAdapter,
  selectTotal: selectSharedAnalysisResultsTotalAdapter,
} = adapter.getSelectors();

export function reducer(state: State | undefined, action: Action) {
  return sharedAnalysisResultsReducer(state, action);
}
